import { computed, ref } from 'vue'
import { createInjectionState } from '@vueuse/core'
import $ from 'jquery'

const [useProvideVideoShow, _useVideoShow] = createInjectionState(() => {
  const playerRef = ref(null)
  const quickConversationRef = ref(null)
  const isQuickConversationModal = computed(() => {
    if (!quickConversationRef.value) {
      return false
    }
    return $(quickConversationRef.value.$el).is('.QuickConversationModal')
  })

  return {
    quickConversationRef,
    isQuickConversationModal,
    playerRef
  }
})

function useVideoShow () {
  return _useVideoShow() ?? {
    quickConversationRef: ref(null)
  }
}

export {
  useProvideVideoShow,
  useVideoShow
}
